import { OrganizationInfo } from "@/pages/organisaties/gegevens/OrganizationInfo"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/organisaties/$organizationId/gegevens/",
)({
  component: OrganizationOverview,
  beforeLoad: () => checkPermissions("read", "organizations"),
})

function OrganizationOverview() {
  return <OrganizationInfo />
}
